import { finalize } from 'rxjs/operators';
import { ticketFormErrors, ticketHasMessage, ticketRequestError } from '../ticket-form.utils';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { TicketService } from 'src/app/Service/Ticket/Ticket.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { environment } from 'src/environments/environment';
import { Ticket_Interface } from 'src/app/Interface/Ticket_Interface';

@Component({
  selector: 'app-TicketReply',
  templateUrl: './TicketReply.component.html',
  styleUrls: ['./TicketReply.component.css', '../ticket-shared.css']
})
export class TicketReplyComponent implements OnInit {
  ErrorMessage = '';
  ValidationErrors: { [key: string]: string } = {};

  @Input() canReply = false;
  @Input() Ticket_Selected:Ticket_Interface
  @Output() OnBack_Ticket_Action = new EventEmitter<number>();
  public Editor = ClassicEditor;
  public model = {
    editorData: ''
};
  public config = {
    language: 'fa'
};

  constructor(
    private Alertify_Service:AlertifyService,
    private Ticket_Service:TicketService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
  }



  //#region Image
  BaseUrl=environment.BaseUrl
  UploadImageSrc_List:Array<string>=[]
  UploadImageSrc:string=''
  InProccessing_Image1:boolean=false
  uploadImage1(files) {
    if (this.InProccessing_Image1 || !files || files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1=true

    this.Ticket_Service.uploadFile(formData).pipe(finalize(() => this.InProccessing_Image1 = false)).subscribe(
      data=>{
        this.InProccessing_Image1=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.UploadImageSrc=data['filename']
        }
      }, error => { this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage); }
    )

  }

  Remove_uploadImage1(){
    this.UploadImageSrc=''
  }

  Add_uploadImage1(){
    this.UploadImageSrc_List.push(this.UploadImageSrc)
    this.UploadImageSrc=''
    this.Alertify_Service.SuccessMessage("به جدول اضافه شد")
  }

  UploadImageSrc_List_Delete(id:number)
      {
        this.UploadImageSrc_List.splice(id,1)
        this.Alertify_Service.SuccessMessage("حذف شد")
      }

    modalRef_Image: any;
    ModalimageUrl:string=''
    openModal(template: TemplateRef<any>,imageUrl:string) {
      this.ModalimageUrl=imageUrl
      this.modalRef_Image = this.modalService.show(template);
    }

//#endregion


  InProccessing:boolean=false
  onSubmitForm(){
    if (this.InProccessing || this.InProccessing_Image1 || !this.canReply || !this.Ticket_Selected?.id) return;
    this.ErrorMessage = '';
    this.ValidationErrors = {};
    if (!ticketHasMessage(this.model.editorData)) { this.ValidationErrors.message = 'متن پاسخ الزامی است.'; return; }
    this.InProccessing = true;
    this.Ticket_Service.ReplyTicket(this.model.editorData, this.Ticket_Selected.id, this.UploadImageSrc_List)
      .pipe(finalize(() => this.InProccessing = false)).subscribe({
        next: () => {
          this.model.editorData = '';
          this.UploadImageSrc_List = [];
          this.canReply = false;
          this.Alertify_Service.SuccessMessage('اطلاعات در سامانه ثبت شد');
          this.OnSet_Back_Ticket();
        },
        error: error => {
          this.ErrorMessage = ticketRequestError(error);
          this.Alertify_Service.ErrorMessage(this.ErrorMessage);
          if (error?.status === 409 || error?.status === 404) this.canReply = false;
        }
      });
  }

  OnSet_Back_Ticket(){
    this.OnBack_Ticket_Action.emit(-1);
  }


}
